module.exports = __webpack_public_path__ + "jobboard.png?433925180a3003b0a13a152fd2ae3b68";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aupair/jobboard.png
// module id = 302
// module chunks = 0